import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";

export const updateModuleCompletion = async (moduleId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction:
            "core_completion_update_activity_completion_status_manually",
          cmid: moduleId,
          completed: 1,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};
